import React from "react";
import { Button, ButtonTypeMap, styled } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

const CustomButton: OverridableComponent<ButtonTypeMap> = styled(
    Button,
    {},
)(({ theme }) => ({
    backgroundColor: "var(--mscp-p-111-7-c)",
    color: "var(--mscp-color-white)",
    textTransform: "none",
    borderRadius: 0,
    padding: "10px",
    "&:hover": {
        backgroundColor: "var(--mscp-p-111-7-c)",
    },
    "&.active": {
        backgroundColor: "white",
    },
}));

export default CustomButton;
